jQuery(document).ready(function ($) {

    // new cleanner version for the page
    $('[data-pair-trigger]').on('click', function () {

        var step1 = $(this).data('pair-trigger');
        var step2 = $('[data-pair-target="' + step1 + '"]');

        var bundle = step1.split('-');

        /* remove class form not needed elements and add to the selected ones*/
        $('[data-pair-trigger^="' + bundle[0] + '-"]').removeClass('is-active');
        $('[data-pair-target^="' + bundle[0] + '-"]').removeClass('is-active');
        $(step2).addClass('is-active');
        $(this).addClass('is-active');
    });

    //mobile version
    $(".js-pairs-select").on("change", function () {
        var step1 = this.value;
        var step2 = $('[data-pair-trigger="' + step1 + '"]');
        var step3 = $('[data-pair-target="' + step1 + '"]');

        var bundle = step1.split("-");

        /* remove class form not needed elements and add to the selected ones*/
        $('[data-pair-trigger^="' + bundle[0] + '-"]').removeClass('is-active');
        $('[data-pair-target^="' + bundle[0] + '-"]').removeClass('is-active');
        $(step2).addClass("is-active");
        $(step3).addClass("is-active");
    });
});
